import axios from "axios";
import { serverUrl } from "@/serverUrl";
import router from "@/router/router";  // Importa direttamente il router

const axiosInstance = axios.create({
  baseURL: serverUrl,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      try {
        const verifyResponse = await axios.get(`${serverUrl}/verify-token`, {
          headers: { Authorization: `${token}` },
        });

        if (verifyResponse.data.valid) {
          config.headers["Authorization"] = `${token}`;
        } else {
          throw new Error("Token non valido");
        }
      } catch (error) {
        console.error("Errore nella verifica del token:", error);
        alert("Sessione scaduta, si prega di rieseguire l'accesso.");
        localStorage.removeItem("token");
        router.push("/login");  
        throw error;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
